import {Component, OnInit} from '@angular/core';
import {WancomHttpService} from '../../../services/wancom-http/wancom-http.service';
import {TitleService} from '../../../services/title/title.service';

@Component({
	selector: 'wnvw-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

	constructor(private http: WancomHttpService, private title$: TitleService) {
		this.title$.next('home');
	}

	ngOnInit(): void {
	}

	test() {
		this.title$.next('toto');
		this.http.get('test')
			.subscribe((r: any) => {
				/*alert(r.test);*/
				this.title$.next(r.test);
			});
	}
}
